import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap";
import axios from "axios";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8A2BE2", "#DC143C"];

const ExpenseSummaryDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch dashboard summary
  const fetchSummary = async () => {
    try {
      const res = await axios.get("https://api.hanoch.in/expense/dashboard/");
      setSummary(res.data);
    } catch (error) {
      console.error("Error fetching summary data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!summary) {
    return (
      <div className="text-center py-5 text-muted">
        No summary data available.
      </div>
    );
  }

  return (
   
      <Card className="shadow-sm">
        <CardBody>
          <CardTitle tag="h4" className="text-center mb-4">
            Expense Summary Dashboard
          </CardTitle>

          {/* ---- Totals Summary ---- */}
          <Container className="mb-4">
  <Row className="justify-content-center text-center g-3">
    {[
      { label: "Total Expense", value: summary.total_expense, color: "text-primary" },
      { label: "Total Paid", value: summary.total_paid, color: "text-success" },
      { label: "Total Unpaid", value: summary.total_unpaid, color: "text-danger" },
      { label: "Today’s Expense", value: summary.today_expense, color: "text-warning" },
      { label: "Monthly Expense", value: summary.monthly_expense, color: "text-info" },
    ].map((item, index) => (
      <Col
        key={index}
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="12"
        className="d-flex justify-content-center"
      >
        <Card className="p-3 bg-light border-0 shadow-sm w-100 text-center">
          <h6 className="text-muted">{item.label}</h6>
          <h5 className={item.color}>₹{item.value}</h5>
        </Card>
      </Col>
    ))}
  </Row>
</Container>

          {/* <Container 
          className="justify-content-between align-items-center">
          <Row className="mb-4 text-center">
            <Col md={2} sm={6} xs={12}>
              <Card className="p-3 bg-light border-0 shadow-sm">
                <h6 className="text-muted">Total Expense</h6>
                <h5 className="text-primary">₹{summary.total_expense}</h5>
              </Card>
            </Col>
            <Col md={2} sm={6} xs={12}>
              <Card className="p-3 bg-light border-0 shadow-sm">
                <h6 className="text-muted">Total Paid</h6>
                <h5 className="text-success">₹{summary.total_paid}</h5>
              </Card>
            </Col>
            <Col md={2} sm={6} xs={12}>
              <Card className="p-3 bg-light border-0 shadow-sm">
                <h6 className="text-muted">Total Unpaid</h6>
                <h5 className="text-danger">₹{summary.total_unpaid}</h5>
              </Card>
            </Col>
            <Col md={2} sm={6} xs={12}>
              <Card className="p-3 bg-light border-0 shadow-sm">
                <h6 className="text-muted">Today’s Expense</h6>
                <h5 className="text-warning">₹{summary.today_expense}</h5>
              </Card>
            </Col>
            <Col md={2} sm={6} xs={12}>
              <Card className="p-3 bg-light border-0 shadow-sm">
                <h6 className="text-muted">Monthly Expense</h6>
                <h5 className="text-info">₹{summary.monthly_expense}</h5>
              </Card>
            </Col>
          </Row>
</Container> */}
          {/* ---- Category Summary ---- */}
          <Row className="mt-4">
            {/* <Col lg={6} md={12}>
              <h5 className="text-center mb-3">Category-wise Expense</h5>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={summary.category_summary}
                    dataKey="total"
                    nameKey="category__name"
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#8884d8"
                    label
                  >
                    {summary.category_summary.map((_, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </Col> */}
 <Col lg={6} md={12}>
              <h5 className="text-center mb-3">Project-wise Expense</h5>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={summary.project_summary}
                  margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="project__name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="total" fill="#8884d8" name="Total Expense" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
            {/* ---- User Summary ---- */}
            <Col lg={6} md={12}>
              <h5 className="text-center mb-3">User-wise Expense</h5>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={summary.user_summary}
                  margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="person__name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="total" fill="#00C49F" name="Total Expense" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
          </Row>

          {/* ---- Project Summary ---- */}
          <Row className="mt-4">
           
          </Row>
        </CardBody>
      </Card>
   
  );
};

export default ExpenseSummaryDashboard;
